import { useContext, useState } from "react";
import { ParameterContext } from '../../contexts/ParameterContext';
import { useEffect } from "react";
import * as paramService from '../services/parameterService'

export default function VersionForm() {

    const [nomParams, setNomParams] = useState([]);
    const { version } = useContext(ParameterContext)


    return (
        <div className="col-12">
            <div className="overflow-auto card recent-sales">
                <div className="card-body">
                    <h5 className="card-title"><span>Списък с версии</span></h5>

                    {(!nomParams) ? (<p>...</p>) : (
                        <>
                            <div className="p-4">
                                <div dangerouslySetInnerHTML={{ __html: version.replace(/\n/g, '<br/>') }} />
                            </div>
                        </>
                    )}

                </div>
            </div>
        </div>
    )
}